module.exports = __webpack_public_path__ + "img/location.d52d4594.svg";